import React from 'react';
import { User } from 'lucide-react';
import { useTranslation } from '../i18n';
import { getInitials } from './PostCard';

/**
 * Attribution line shown over a Movement Story card's cover.
 *  - Member submission (source 'user', not anonymous): avatar + first name.
 *  - Anonymous submission: generic icon + the chosen display name.
 *  - Curated (source 'system'): a subtle source label, when present.
 */
export default function StoryAttribution({ story, compact = false }) {
  const { t } = useTranslation('movement');
  const author = story.author || {};

  if (story.source === 'user') {
    if (author.anonymous) {
      return (
        <span className={`ms-author${compact ? ' ms-author--compact' : ''}`}>
          <span className="ms-author-avatar ms-author-avatar--anon"><User size={compact ? 11 : 12} /></span>
          <span className="ms-author-name">{author.name || t('anonymous')}</span>
        </span>
      );
    }
    const firstName = (author.name || '').split(' ')[0] || author.username || '';
    return (
      <span className={`ms-author${compact ? ' ms-author--compact' : ''}`}>
        {author.avatar
          ? <img className="ms-author-avatar" src={author.avatar} alt="" loading="lazy" />
          : <span className="ms-author-avatar ms-author-avatar--initials">{getInitials(author.name)}</span>}
        <span className="ms-author-name">{firstName}</span>
      </span>
    );
  }

  if (story.sourceName) {
    return <span className={`ms-source-tag${compact ? ' ms-source-tag--compact' : ''}`}>{story.sourceName}</span>;
  }
  return null;
}
